// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-wrap { padding: 32px 40px; flex: 1; overflow-y: auto; }
.settings-title { font-size: 18px; font-weight: 600; margin-bottom: 24px; }
.settings-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 20px 24px;
  margin-bottom: 20px;
  break-inside: avoid;
}
/* Cards flow into as many ~380px columns as the window allows (one column on mobile) */
.settings-grid { column-width: 380px; column-gap: 20px; max-width: 1640px; }
.settings-section-title {
  font-size: 12px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.07em; color: var(--text-secondary); margin-bottom: 16px;
}
.settings-form { display: flex; flex-direction: column; gap: 14px; }
.settings-label { display: flex; flex-direction: column; gap: 5px; font-size: 12px; color: var(--text-secondary); }
.settings-input {
  background: var(--bg-input); border: 1px solid var(--border);
  border-radius: 2px; color: var(--text-primary); font-size: 13px; padding: 6px 10px;
}
.settings-input:focus { border-color: var(--accent-light); outline: none; }
.settings-avatar-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.settings-error   { color: var(--red);   font-size: 12px; }
.settings-success { color: var(--green); font-size: 12px; }
.settings-hint    { color: var(--text-muted); font-size: 12px; margin-top: 8px; }

.settings-theme-row {
  display: flex;
  gap: 8px;
}
.settings-theme-btn {
  flex: 1;
  padding: 8px 0;
  border-radius: 2px;
  border: 1px solid var(--border);
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}
.settings-theme-btn:hover { background: var(--bg-hover); color: var(--text-primary); }
.settings-theme-btn.active {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
}

.settings-notif-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
}
.settings-notif-label  { color: var(--text-secondary); }
.settings-notif-status { font-weight: 600; }
.notif-granted  { color: var(--green); }
.notif-denied   { color: var(--red); }
.notif-default  { color: var(--text-muted); }

.settings-printer-list { display: flex; flex-direction: column; gap: 4px; }
.settings-printer-item {
  display: flex; align-items: center; gap: 10px;
  font-size: 13px; color: var(--text-primary);
  padding: 4px 0;
}
.settings-printer-item label { cursor: pointer; }
.settings-printer-item input[type="checkbox"] { margin: 0; }
.settings-printer-name { color: var(--text-secondary); }
.settings-printer-displayname {
  flex: 1;
  max-width: 220px;
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 3px;
  color: var(--text-primary);
  font-size: 12px;
  padding: 3px 7px;
  height: 26px;
}

@media (max-width: 768px) {
  .settings-wrap { padding: 20px 16px; }
  .settings-card { max-width: 100%; }
}
`, "",{"version":3,"sources":["webpack://./src/components/settings/Settings.css"],"names":[],"mappings":"AAAA,iBAAiB,kBAAkB,EAAE,OAAO,EAAE,gBAAgB,EAAE;AAChE,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC1E;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;AACA,uFAAuF;AACvF,iBAAiB,mBAAmB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC3E;EACE,eAAe,EAAE,gBAAgB,EAAE,yBAAyB;EAC5D,sBAAsB,EAAE,4BAA4B,EAAE,mBAAmB;AAC3E;AACA,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACnE,kBAAkB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,eAAe,EAAE,4BAA4B,EAAE;AAClH;EACE,2BAA2B,EAAE,+BAA+B;EAC5D,kBAAkB,EAAE,0BAA0B,EAAE,eAAe,EAAE,iBAAiB;AACpF;AACA,wBAAwB,iCAAiC,EAAE,aAAa,EAAE;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,oBAAoB,iBAAiB,IAAI,eAAe,EAAE;AAC1D,oBAAoB,mBAAmB,EAAE,eAAe,EAAE;AAC1D,oBAAoB,wBAAwB,EAAE,eAAe,EAAE,eAAe,EAAE;;AAEhF;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,OAAO;EACP,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;AAC/D;AACA,4BAA4B,2BAA2B,EAAE,0BAA0B,EAAE;AACrF;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA,yBAAyB,4BAA4B,EAAE;AACvD,yBAAyB,gBAAgB,EAAE;AAC3C,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,iBAAiB,EAAE;AACrC,kBAAkB,wBAAwB,EAAE;;AAE5C,yBAAyB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AAC1E;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,eAAe,EAAE,0BAA0B;EAC3C,cAAc;AAChB;AACA,+BAA+B,eAAe,EAAE;AAChD,gDAAgD,SAAS,EAAE;AAC3D,yBAAyB,4BAA4B,EAAE;AACvD;EACE,OAAO;EACP,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB,kBAAkB,EAAE;EACrC,iBAAiB,eAAe,EAAE;AACpC","sourcesContent":[".settings-wrap { padding: 32px 40px; flex: 1; overflow-y: auto; }\n.settings-title { font-size: 18px; font-weight: 600; margin-bottom: 24px; }\n.settings-card {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  padding: 20px 24px;\n  margin-bottom: 20px;\n  break-inside: avoid;\n}\n/* Cards flow into as many ~380px columns as the window allows (one column on mobile) */\n.settings-grid { column-width: 380px; column-gap: 20px; max-width: 1640px; }\n.settings-section-title {\n  font-size: 12px; font-weight: 700; text-transform: uppercase;\n  letter-spacing: 0.07em; color: var(--text-secondary); margin-bottom: 16px;\n}\n.settings-form { display: flex; flex-direction: column; gap: 14px; }\n.settings-label { display: flex; flex-direction: column; gap: 5px; font-size: 12px; color: var(--text-secondary); }\n.settings-input {\n  background: var(--bg-input); border: 1px solid var(--border);\n  border-radius: 2px; color: var(--text-primary); font-size: 13px; padding: 6px 10px;\n}\n.settings-input:focus { border-color: var(--accent-light); outline: none; }\n.settings-avatar-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.settings-error   { color: var(--red);   font-size: 12px; }\n.settings-success { color: var(--green); font-size: 12px; }\n.settings-hint    { color: var(--text-muted); font-size: 12px; margin-top: 8px; }\n\n.settings-theme-row {\n  display: flex;\n  gap: 8px;\n}\n.settings-theme-btn {\n  flex: 1;\n  padding: 8px 0;\n  border-radius: 2px;\n  border: 1px solid var(--border);\n  background: var(--bg-tertiary);\n  color: var(--text-secondary);\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n.settings-theme-btn:hover { background: var(--bg-hover); color: var(--text-primary); }\n.settings-theme-btn.active {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: #fff;\n}\n\n.settings-notif-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 13px;\n}\n.settings-notif-label  { color: var(--text-secondary); }\n.settings-notif-status { font-weight: 600; }\n.notif-granted  { color: var(--green); }\n.notif-denied   { color: var(--red); }\n.notif-default  { color: var(--text-muted); }\n\n.settings-printer-list { display: flex; flex-direction: column; gap: 4px; }\n.settings-printer-item {\n  display: flex; align-items: center; gap: 10px;\n  font-size: 13px; color: var(--text-primary);\n  padding: 4px 0;\n}\n.settings-printer-item label { cursor: pointer; }\n.settings-printer-item input[type=\"checkbox\"] { margin: 0; }\n.settings-printer-name { color: var(--text-secondary); }\n.settings-printer-displayname {\n  flex: 1;\n  max-width: 220px;\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  border-radius: 3px;\n  color: var(--text-primary);\n  font-size: 12px;\n  padding: 3px 7px;\n  height: 26px;\n}\n\n@media (max-width: 768px) {\n  .settings-wrap { padding: 20px 16px; }\n  .settings-card { max-width: 100%; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
